import React, { createContext, useState, useEffect, useContext } from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

const AgentContext = createContext();

export const AgentProvider = ({ children }) => {
  const { accounts, instance } = useMsal();
  const [agentCode, setAgentCode] = useState(null);
  const [agentName, setAgentName] = useState(null);
  const [orders, setOrders] = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(false);
  const [ordersError, setOrdersError] = useState(null);

  useEffect(() => {
    if (!accounts || accounts.length === 0) return;

    const fetchAgentData = async () => {
      setOrdersLoading(true);
      setOrdersError(null);
      try {
        const result = await instance.acquireTokenSilent({ ...loginRequest, account: accounts[0] });
        const headers = { Authorization: `Bearer ${result.accessToken}` };
        const base = process.env.REACT_APP_BACKEND_BASE_URL;

        const agentRes = await fetch(`${base}/api/agent-complaints/agent`, { headers });
        if (!agentRes.ok) throw new Error('שגיאה בקבלת פרטי הסוכן');
        const agentData = await agentRes.json();

        setAgentCode(agentData.AGENTCODE);
        setAgentName(agentData.AGENTNAME);

        const ordersRes = await fetch(
          `${base}/api/agent-complaints/orders?agentCode=${agentData.AGENTCODE}`,
          { headers }
        );
        if (!ordersRes.ok) throw new Error('שגיאה בקבלת ההזמנות');
        const ordersData = await ordersRes.json();

        setOrders(ordersData.orders || []);
      } catch (err) {
        setOrdersError(err.message);
      } finally {
        setOrdersLoading(false);
      }
    };

    fetchAgentData();
  }, [accounts.length]);

  return (
    <AgentContext.Provider value={{ agentCode, agentName, orders, ordersLoading, ordersError }}>
      {children}
    </AgentContext.Provider>
  );
};

export const useAgent = () => {
  const context = useContext(AgentContext);
  if (!context) throw new Error('useAgent must be used within AgentProvider');
  return context;
};
